import { get, post } from './httpClient';
import type { Task, AuthorizedTaskMap, LeaveAccumulation } from '../types';

interface AllTasksResponse {
  Items: Task[];
}

interface AuthorizedTasksResponse {
  Item?: {
    employee_id: { N: string };
    authorized_task_map: { M: AuthorizedTaskMap };
  };
}

interface LeaveAccumulationResponse {
  Items: LeaveAccumulation[];
}

export const taskService = {
  // Get all tasks
  getAllTasks: async (): Promise<Task[]> => {
    const response = await get<AllTasksResponse>('/db/tasks/name,leave,overhead/None');
    return response.data.Items;
  },

  // Get authorized tasks for an employee
  getAuthorizedTasks: async (employeeId: string): Promise<AuthorizedTaskMap> => {
    try {
      const response = await get<AuthorizedTasksResponse>(`/db/authorized_tasks/employee_id/${employeeId}`);
      return response.data.Item?.authorized_task_map?.M || {};
    } catch (error) {
      // Return empty map if not found
      return {};
    }
  },

  // Save authorized tasks
  saveAuthorizedTasks: async (employeeId: string, authorizedTaskMap: any): Promise<void> => {
    await post('/db/authorized_tasks', {
      employee_id: employeeId,
      authorized_task_map: authorizedTaskMap,
    });
  },

  // Save all tasks (admin only)
  saveAllTasks: async (tasks: Array<{ name: string; leave: boolean; overhead: boolean }>): Promise<void> => {
    await post('/db/all_tasks', { tasks });
  },

  // Get leave accumulation codes
  getLeaveAccumulation: async (): Promise<LeaveAccumulationResponse> => {
    try {
      const response = await get<LeaveAccumulationResponse>('/db/leave_accumulation');
      return response.data;
    } catch (error) {
      return { Items: [] };
    }
  },
};
